<script setup lang="ts">

import { faUserTag } from '@fortawesome/pro-regular-svg-icons'
import { faCrown } from '@fortawesome/pro-solid-svg-icons'

import { AppBadge, BadgeCustomerBrand } from '@shared/ui/badges'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

import { useCustomerLabels } from '../model/customer-labels.hook'

defineOptions({
  name: 'CustomerLabels',
})

const {
  refBrand,
  isGo,
  refLabels,
  isDeal,
  refDealText,
  refDealOwner,
} = useCustomerLabels()
</script>

<template>
  <span class="customer-labels">
    <AppBadge
      v-if="isGo"
      color="emerald"
      text="Goal"
      title="GO lead"
    />
    <BadgeCustomerBrand
      :brand="refBrand"
      view="icon"
    />
    <template v-if="refLabels">
      <AppTooltip
        v-if="refLabels.is_premium"
        text="Premium tutor"
        size="small"
        placement="top"
      >
        <AppIcon
          :icon="faCrown"
          size="small"
          color="amber-500"
        />
      </AppTooltip>
      <AppTooltip
        v-if="refLabels.is_premium_tutor_trial"
        text="Premium tutor trial"
        size="small"
        placement="top"
      >
        <AppIcon
          :icon="faCrown"
          size="small"
          color="blue-500"
        />
      </AppTooltip>
      <AppBadge
        v-if="refLabels.sale_wo_upsell"
        color="indigo"
        text="Upsell"
      />
      <AppTooltip
        v-if="isDeal"
        :text="refDealOwner"
        size="small"
        placement="bottom"
      >
        <AppBadge
          color="blue"
          :text="refDealText"
          :prepend-icon="faUserTag"
        />
      </AppTooltip>
      <AppBadge
        v-if="refLabels.ai_summarize"
        color="orange"
        text="AI feat."
        title="AI features"
      />
      <AppBadge
        v-if="refLabels.has_referrer"
        color="indigo"
        text="Referral"
      />
      <AppBadge
        v-if="refLabels.is_four_weeks_subscription"
        color="indigo"
        text="28 days"
        title="28 days"
      />
    </template>
  </span>
</template>

<style scoped lang="scss" src="./CustomerLabels.scss" />
